import Component from './Component'

export default class Clock extends Component {

	static _type = 'Clock'

	_timer

	constructor (params) {
        super(params)

		// Default parameters
        this.params = Object.assign({
            format: 'HH:mm',
            interval: 1000
        }, this.params)
    }

	tether () {
		super.tether()

		this.update()
        this._timer = setInterval(this.update.bind(this), this.params.interval)
	}

    destroy() {

		// Stop the timer
        if (this._timer !== null) {
			clearInterval(this._timer)
			this._timer = null
		}

        super.destroy()
    }

    update() {
		this.base.innerHTML = Anvil.moment().format(this.params.format)
    }
}
